import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { fm } from '../../utils';
import { TrendingUp, TrendingDown } from 'lucide-react';

const TopProducts = ({ data = [] }) => (
  <div className="bg-white dark:bg-surface-800 rounded-2xl border border-surface-100 dark:border-surface-700 shadow-soft p-4">
    <h4 className="text-[11px] font-semibold text-surface-400 uppercase tracking-wider mb-3">En Çok Satan Ürünler</h4>
    {data.length === 0 ? (
      <div className="h-48 flex items-center justify-center text-xs text-surface-300">Veri bulunamadı</div>
    ) : (
      <div className="space-y-2">
        {data.slice(0, 10).map((item, i) => (
          <div key={item.urunID || i} className="flex items-center gap-3 p-2 rounded-xl hover:bg-surface-50 dark:hover:bg-surface-700/30 transition-colors">
            <div className={`w-6 h-6 rounded-lg flex items-center justify-center text-[10px] font-bold text-white ${i < 3 ? 'bg-emerald-500' : 'bg-surface-300 dark:bg-surface-600'}`}>
              {i + 1}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-1.5">
                <p className="text-xs font-semibold text-surface-800 dark:text-white truncate">{item.urunAdi}</p>
                {item.trend !== undefined && (
                  item.trend > 0 ? <TrendingUp size={10} className="text-emerald-500 flex-shrink-0" /> : item.trend < 0 ? <TrendingDown size={10} className="text-red-500 flex-shrink-0" /> : null
                )}
              </div>
              <p className="text-[10px] text-surface-400">{item.kategori}</p>
            </div>
            <div className="text-right">
              <p className="text-xs font-bold text-surface-800 dark:text-white">{fm(item.toplamTutar)}</p>
              <p className="text-[10px] text-surface-400">{item.toplamAdet} adet</p>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

const CategoryChart = ({ data = [] }) => (
  <div className="bg-white dark:bg-surface-800 rounded-2xl border border-surface-100 dark:border-surface-700 shadow-soft p-4">
    <h4 className="text-[11px] font-semibold text-surface-400 uppercase tracking-wider mb-3">Kategori Bazlı Satışlar</h4>
    {data.length === 0 ? (
      <div className="h-48 flex items-center justify-center text-xs text-surface-300">Veri bulunamadı</div>
    ) : (
      <div className="h-48">
        <ResponsiveContainer>
          <BarChart data={data} layout="vertical" margin={{ left: 10 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" horizontal={false} />
            <XAxis type="number" tick={{ fontSize: 10, fill: '#94a3b8' }} axisLine={false} tickLine={false} tickFormatter={v => fm(v)} />
            <YAxis type="category" dataKey="kategoriAdi" tick={{ fontSize: 10, fill: '#94a3b8' }} axisLine={false} tickLine={false} width={80} />
            <Tooltip formatter={(v) => fm(v)} />
            <Bar dataKey="toplamTutar" radius={[0, 4, 4, 0]} maxBarSize={20}>
              {data.map((_, i) => (
                <rect key={i} fill={['#10b981', '#3b82f6', '#f59e0b', '#8b5cf6', '#f43f5e', '#06b6d4', '#84cc16'][i % 7]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    )}
    {data.length > 0 && (
      <div className="grid grid-cols-2 gap-2 mt-3">
        {data.map((item, i) => (
          <div key={i} className="bg-surface-50 dark:bg-surface-700/30 rounded-xl p-2">
            <p className="text-[10px] text-surface-400 truncate">{item.kategoriAdi}</p>
            <p className="text-xs font-bold text-surface-800 dark:text-white">{fm(item.toplamTutar)}</p>
            <p className="text-[9px] text-surface-400">%{item.yuzde}</p>
          </div>
        ))}
      </div>
    )}
  </div>
);

export { TopProducts, CategoryChart };
